window.GetId = {
  onComplete(verificationId, reference) {
    if (window.vueRoot) {
      window.vueRoot.$emit('verification-completed', { verificationId, reference })
    }
  }
}
